/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
import { useMutation } from '@apollo/client';
import imgBg from '@assets/images/static/bg-splashscreen.png';
import { Site, Thematique } from '@zeus/index';
import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
//import { useLingui } from '@lingui/react';
import styled from 'styled-components';
import {
  GQL_CREATE_TRACKING_THEMATIQUE,
  GQL_UPDATE_TRACKING_THEMATIQUE,
} from '~/gql/tracking-thematique/tracking-thematique';
import useConnectionStore, {
  TrackingState,
} from '~/helpers/store/connection/connection';

import { deleteTrackingByTrackingId } from '~/pages/components/game/activities-forms/utils';
import { RenderActivity } from '~/pages/components/game/render-activiy';
import Layout from '~/pages/layouts/empty';
import { classic } from '~/themes/classic';
import { TActivity } from '~/utils/airtable/types/types';
import { getActivitiesByThematiquesAndSite } from '~/utils/airtable/utils';
import { compareByOrder } from '~/utils/common/utils';
import { useConnection } from '../../helpers/hooks/connection';

function ThematiquePage() {
  //const { i18n } = useLingui();
  const navigate = useNavigate();
  const { site, thematique } = useParams();
  const {
    connectionId,
    currentTrackingThematiqueId,
    setCurrentTrackingThematiqueId,
    setCurrentThematique,
    setCurrentSite,
    addTracking,
    currentTrackings,
    setCurrentTrackings,
  } = useConnectionStore();

  const [activities, setActivities] = useState<TActivity[]>([]);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isDataReady, setIsDataReady] = useState<boolean>(false);

  const sessionUuid = useConnection();
  const [updateTrackingThematique] = useMutation(
    GQL_UPDATE_TRACKING_THEMATIQUE
  );

  const [createOrUpdateTracking] = useMutation(GQL_CREATE_TRACKING_THEMATIQUE, {
    onCompleted: (data) => {
      if (
        data.createOrUpdateTrackingThematique.id !== currentTrackingThematiqueId
      ) {
        setCurrentTrackingThematiqueId(
          data.createOrUpdateTrackingThematique.id
        );
        setCurrentThematique(data.createOrUpdateTrackingThematique.thematique);
        setCurrentSite(data.createOrUpdateTrackingThematique.site);
      }
    },
  });

  useEffect(() => {
    const _activities = getActivitiesByThematiquesAndSite(
      site?.toUpperCase() as Site,
      thematique as Thematique
    ).sort(compareByOrder);
    setActivities(_activities);
  }, []);

  useEffect(() => {
    void createNewTrackingThematique();
  }, []);

  async function createNewTrackingThematique() {
    try {
      setIsDataReady(false);
      if (sessionUuid) {
        // verifier si il y a dans la liste de trackings un avec la même thematique et sessionId

        const indExist = currentTrackings.findIndex(
          (el) =>
            el.sessionUuid === sessionUuid &&
            el.thematiqueName === thematique &&
            el.siteName === site?.toUpperCase()
        );

        if (indExist !== -1) {
          setCurrentTrackingThematiqueId(
            currentTrackings[indExist].trackingThematiqueId
          );
          setCurrentThematique(currentTrackings[indExist].thematiqueName);

          setCurrentIndex((currentTrackings[indExist]?.activityOrder ?? 1) - 1);

          return;
        }

        const { data } = await createOrUpdateTracking({
          variables: {
            sessionUuid,
            site: site?.toUpperCase() as Site,
            thematique: thematique as Thematique,
            ...(currentTrackingThematiqueId && {
              trackingThematiqueId: currentTrackingThematiqueId,
            }),
            ...(connectionId && { connectionId: connectionId }),
            currentActivityOrder: 0,
          },
        });

        if (data?.createOrUpdateTrackingThematique) {
          setCurrentTrackingThematiqueId(
            data.createOrUpdateTrackingThematique.id
          );
          setCurrentThematique(
            data.createOrUpdateTrackingThematique.thematique
          );
          setCurrentSite(data.createOrUpdateTrackingThematique.site);

          const newTracking: TrackingState = {
            thematiqueName: data.createOrUpdateTrackingThematique.thematique,
            trackingThematiqueId: data.createOrUpdateTrackingThematique.id,
            siteName: data.createOrUpdateTrackingThematique.site,
            sessionUuid:
              data.createOrUpdateTrackingThematique.connection.sessionUuid,
            activityOrder: 1,
          };
          if (
            !currentTrackings.find(
              (el) =>
                el.sessionUuid === newTracking.sessionUuid &&
                el.trackingThematiqueId === newTracking.trackingThematiqueId
            )
          ) {
            addTracking(newTracking);
          }
        }
      }
    } finally {
      setIsDataReady(true);
    }
  }

  async function finalTrackingThematique() {
    if (currentTrackingThematiqueId) {
      await updateTrackingThematique({
        variables: {
          id: currentTrackingThematiqueId,
          terminatedAt: new Date(),
        },
      });
    }
  }

  function next() {
    if (activities.length === 0) return;
    if (currentIndex + 1 < activities.length) {
      setCurrentIndex((old) => old + 1);
    }
    if (currentIndex + 1 === activities.length) {
      // supprimer cette thematique de la liste tracking de store
      setCurrentTrackings(
        deleteTrackingByTrackingId(
          currentTrackingThematiqueId,
          currentTrackings
        )
      );
      setCurrentTrackingThematiqueId(null);
      setCurrentThematique(null);

      void finalTrackingThematique();
      navigate(`/${site}`);
    }
  }

  return (
    <Layout $background={imgBg} $menuWithLogo>
      <Container>
        {activities.length > 0 && isDataReady && (
          <RenderActivity
            currentActivity={activities[currentIndex]}
            nextActivity={next}
          />
        )}
      </Container>
    </Layout>
  );
}

export default ThematiquePage;

const Container = styled.div`
  align-items: center;
  background-color: ${classic.token?.colorBgBase};
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
`;
